import { formatLocalDateTime, formatarDataSemFuso, returnDate } from "../formatDate";

export function formatarDataHora(dataIso) {
    if (!dataIso) return "-";
    return formatLocalDateTime(dataIso);
}

export function formatarData(dataIso) {
    if (!dataIso) return "-";
    return formatarDataSemFuso(dataIso);
}

export function tempoDecorrido(dataIso) {
    if (!dataIso) return "-";
    return returnDate(dataIso);
}

export function formatarMoeda(valor) {
    if (valor === null || valor === undefined) return "-";
    return Number(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

// Formata progressivamente conforme a quantidade de dígitos: até 11 dígitos vira CPF
// (000.000.000-00), acima disso vira CNPJ (00.000.000/0000-00). Aceita valor já
// formatado ou cru, pois sempre reconstrói a máscara a partir dos dígitos.
export function formatarCnpjCpf(valor) {
    const digitos = (valor ?? "").toString().replace(/\D/g, "").slice(0, 14);

    if (digitos.length > 11) {
        return digitos
            .replace(/(\d{2})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1/$2")
            .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
    }

    return digitos
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}
